import { render, staticRenderFns } from "./supplier-select-dialog.vue?vue&type=template&id=484fa38b"
import script from "./supplier-select-dialog.vue?vue&type=script&lang=js"
export * from "./supplier-select-dialog.vue?vue&type=script&lang=js"
import style0 from "./supplier-select-dialog.vue?vue&type=style&index=0&id=484fa38b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports